import { Component, ElementRef, HostListener, OnInit } from '@angular/core';

import { EmitterService } from '../../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-account-dropdown-v6',
	styleUrls: ['./account-dropdown-v6.component.css', '../../../../../../assets/styles/styles-v6.css'],
	templateUrl: './account-dropdown-v6.component.html'
})
export class AccountDropdownV6Component implements OnInit {
	public showDropdown: boolean = false;

	constructor(private eRef: ElementRef) {}

	ngOnInit(): void {}

	eventClicked(event: any): void {
		EmitterService.get(event).emit(event);
	}

	@HostListener('document:click', ['$event'])
	clickout(event: any): void {
		if (this.eRef.nativeElement.contains(event.target)) {
			this.showDropdown = !this.showDropdown;
		} else {
			this.showDropdown = false;
		}
	}
}
